"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// Style
var LabelWrapper = function LabelWrapper(_ref) {
  var label = _ref.label,
      className = _ref.className,
      children = _ref.children,
      style = _ref.style,
      error = _ref.error,
      dropdownArrow = _ref.dropdownArrow;

  function getLabel() {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "shpmtc-label-wrapper__label"
    }, label);
  }

  function getError() {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "shpmtc-label-wrapper__error"
    }, error);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "\n        shpmtc-label-wrapper\n        ".concat(dropdownArrow ? 'dropdown-arrow' : '', "\n        ").concat(className, "\n      "),
    style: style
  }, label ? getLabel() : null, children, error ? getError() : null);
};

exports.LabelWrapper = LabelWrapper;
LabelWrapper.defaultProps = {
  label: null,
  className: '',
  children: null,
  style: null,
  error: null,
  dropdownArrow: false
};
LabelWrapper.propTypes = {
  label: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  style: _propTypes.default.instanceOf(Object),
  error: _propTypes.default.string,
  dropdownArrow: _propTypes.default.bool
};